import { StyleSheet, Platform } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius3, colorTextMedium, space4, space5, space6, space2 } = theme();

  return StyleSheet.create({
    contentWrapper: {
      width: "100%",
      ...Platform.select({
        web: {
          height: "100%",
        },
      }),
    },
    image: {
      aspectRatio: 379 / 244,
      width: "100%",
    },
    rounded: {
      borderRadius: borderRadius3,
    },
    subtitle: {
      color: colorTextMedium,
      marginBottom: space4,
    },
    title: {
      marginBottom: space2,
    },
    wrapperLarge: {
      padding: space5,
    },
    wrapperSmall: {
      padding: space6,
    },
  });
};

export { style };
